export default (params) => ({
  trigger: {
    name: 'options_row.view',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
    },
    event: {
      name: 'view_items',
      params: {
        has_highlighted_segment: null,
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
